import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';
import { landing as baseLanding } from './landing-page.style';

export { globalStyle, content, search } from './landing-page.style';

export const landing = css`
  ${baseLanding}
  background: none;
`;

export const container = css`
  background-color: ${tokens.colors.neutral.background.default};
  position: relative;
  overflow: auto;
`;

export const page = css`
  background-color: ${tokens.colors.neutral.background.default};
`;

export const wrapper = css`
  width: 100%;
  max-width: 1280px;
  padding: 0 ${tokens.spacing.s};
  margin: ${tokens.spacing.xl} auto;
`;

export const callToActions = css`
  padding-bottom: ${tokens.spacing.s};
`;

export const ultimateGuides = css`
  padding-bottom: ${tokens.spacing.xxl};
`;
